import { FC } from 'react';
import DeliveryFeeCondition from '../../components/DeliveryFeeCondition/DeliveryFeeCondition';
import ReduceDeliveryFeeCondition from '../../components/ReduceDeliveryFeeCondition/ReduceDeliveryFeeCondition';
import MinimumOrderCondition from '../../components/MinimumOrderCondition/MinimumOrderCondition';
import Text, { TEXT } from 'src/view/components/Text/Text';

const DeliveryConditions: FC = (): JSX.Element => {
  return (
    <div style={{ width: 370 }} className="mr-10">
      <Text text="branch_delivery_conditions_header" type={TEXT.SECTION_HEADER} />
      <div className="d-flex flex-column mt-4 gap-30">
        <MinimumOrderCondition />
        <DeliveryFeeCondition />
        <ReduceDeliveryFeeCondition />
      </div>
    </div>
  );
};

export default DeliveryConditions;
